import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/opt/atlassian/pipelines/agent/build/apps/loyalty/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Nunito\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"nunito\"}");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/loyalty/app/global.css");
